import script from "./CashregisterGeneral.vue?vue&type=script&setup=true&lang=js"
export * from "./CashregisterGeneral.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__